import { useEffect } from "react";
import { LoadMainScreenService } from "../../services/MainScreen";
import {
  Header,
  Slider,
  ProductSlider,
  Category,
  Footer,
  CompetitiveAdvantage,
} from "./index";

const Home = ({ data, setData }) => {
  // const [category_h_list, setCategoryHList] = useState([]);
  // const [categories, setCategories] = useState([]);
  // const [product_h_list, setProductHList] = useState([]);
  // const [sliders, setSliders] = useState([]);
  // const [setting, setSetting] = useState([]);

  // const [banners, setBanners] = useState([]);
  // const [comments, setComments] = useState([]);
  // const [products, setProducts] = useState([]);

  // const [slider_by_product, setSliderByProduct] = useState([]);
  // //* footer
  // const [socials, setSocials] = useState([]);
  // const [about_us, setAboutUs] = useState([]);
  // const [isLoading, setIsLoading] = useState(true);

  return (
    <>
      {/* search overlay */}
      <div className="header-search-overlay" />
      <div className="container">
        {/* Category Box */}
        {data.product_h_list.length > 0 ? (
          <Category
            data={
              data.category_h_list[
                data.category_h_list.findIndex(
                  (x) => x.list_location === "top_top"
                )
              ]
            }
          />
        ) : null}
      </div>
      <Slider model={data.sliders} />
      <CompetitiveAdvantage />
      <div className="container-fluid "></div>
      <div className="container-fluid">
        <div className="row">
          <div className="col-12 col-lg-3 mb-lg-15"></div>
        </div>
        {/* products */}
        <div className></div>
        {/* /products */}
      </div>

      {/* special products */}
      {/* special products */}
      {/* banners */}
      <div className="container">
        {/* products */}
        {data.product_h_list.length > 0 ? (
          <ProductSlider
            data={
              data.product_h_list[
                data.product_h_list.findIndex(
                  (x) => x.list_location === "center_top"
                )
              ]
            }
            setData={setData}
          />
        ) : null}

        {/* Category Box */}
        {data.product_h_list.length > 0 ? (
          <Category
            data={
              data.category_h_list[
                data.category_h_list.findIndex(
                  (x) => x.list_location === "center_center"
                )
              ]
            }
          />
        ) : null}

        {/* products */}
        {data.product_h_list.length > 0 ? (
          <ProductSlider
            data={
              data.product_h_list[
                data.product_h_list.findIndex(
                  (x) => x.list_location === "center_bottom"
                )
              ]
            }
            setData={setData}
          />
        ) : null}
        {data.product_h_list.length > 0
          ? data.product_h_list.map((item) => {
              if (
                item.list_location !== "center_bottom" &&
                item.list_location !== "center_top"
              )
                return (
                  <>
                    <hr />
                    <ProductSlider data={item} setData={setData} />
                  </>
                );
            })
          : null}
      </div>

      {/*footer*/}

      {/*/footer*/}
      {/*/quickview*/}
      {/*quickview*/}
      <form
        name="quickview"
        id="product-quickview-modal"
        className="modal modal-md product-quickview-modal"
        ng-submit="quickview.$valid && submit()"
        tabIndex={-1}
        role="dialog"
        quick-view
        dynamic-form
        noValidate
      >
        <div
          className="modal-dialog product-quickview-modal-dialog"
          role="document"
        >
          <div className="modal-content product-quickview-modal-content">
            <div className="modal-header">
              <h5 className="modal-title product-quickview-modal-title">
                <span ng-bind="title" />
              </h5>
              <button
                type="button"
                className="close product-quickview-modal-close-icon"
                data-dismiss="modal"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body product-quickview-modal-body">
              <div
                className="alert alert-danger validation-summary product-quickview-modal-failed m-0 mb-3"
                ng-if="validation"
                ng-class="{'d-block' : validation}"
              >
                <h6 className="alert-heading validation-summary-title product-quickview-modal-failed-title">
                  <span ng-bind="validation.main" />
                </h6>
              </div>
              <div
                className="alert alert-success product-quickview-modal-succeed mb-0"
                ng-show="succeed"
              >
                <span ng-bind="succeed.description" />
              </div>
              <div ng-show="loading">در حال بارگذاری...</div>
              <div ng-hide="succeed || loading">
                <div
                  className="form-group product-quickview-modal-attribute"
                  ng-repeat="attribute in attributes"
                >
                  <div className="input-group">
                    <div className="input-group-prepend">
                      <span className="input-group-text">
                        {"{"}
                        {"{"}attribute.name{"}"}
                        {"}"}
                      </span>
                    </div>
                    <select
                      id="product-quickview-modal-attribute-{{$index}}"
                      name="attribute{{$index}}"
                      className="form-control product-quickview-modal-attribute-control"
                      ng-model="model.attributes['attribute' + $index]"
                      ng-change="changeAttribute()"
                      ng-disabled="progress"
                      required
                    >
                      <option
                        ng-repeat="value in attribute.values"
                        value="{{attribute.name}}: {{value}}"
                      >
                        {"{"}
                        {"{"}value{"}"}
                        {"}"}
                      </option>
                    </select>
                  </div>
                  <div
                    className="validation-inline product-quickview-modal-inline-error text-danger"
                    ng-messages="quickview['attribute' + $index].$error"
                    ng-show="quickview.$submitted || quickview['attribute' + $index].$dirty"
                  >
                    <span ng-message="required">
                      {"{"}
                      {"{"}attribute.name{"}"}
                      {"}"} را انتخاب کنید.
                    </span>
                  </div>
                </div>
                <div className="form-group product-quickview-modal-quantity">
                  <div className="input-group">
                    <div className="input-group-prepend">
                      <span className="input-group-text">تعداد</span>
                    </div>
                    <input
                      type="number"
                      id="product-quickview-modal-quantity"
                      name="quantity"
                      className="form-control product-quickview-modal-quantity-control"
                      ng-model="model.quantity"
                      ng-disabled="progress"
                      dir="ltr"
                      min={1}
                      max={1000000000}
                      required
                    />
                  </div>
                  <div
                    className="validation-inline product-quickview-modal-inline-error text-danger"
                    ng-messages="quickview.quantity.$error"
                    ng-show="quickview.$submitted || quickview.quantity.$dirty"
                  >
                    <span ng-message="required">تعداد را بنویسید.</span>
                    <span ng-message="min">تعداد را بیش‌تر از 0 بنویسید.</span>
                    <span ng-message="max">
                      تعداد را کم‌تر از 10000000000 بنویسید.
                    </span>
                  </div>
                </div>
                <span
                  className="product-quickview-modal-compare-price text-muted"
                  ng-show="getComparePrice()"
                >
                  <del>
                    {"{"}
                    {"{"}getComparePrice() | number{"}"}
                    {"}"}
                  </del>
                </span>
                <span
                  className="product-quickview-modal-price text-green"
                  ng-show="getPrice()"
                >
                  {"{"}
                  {"{"}getPrice() | number{"}"}
                  {"}"} تومان
                </span>
              </div>
            </div>
            <div className="modal-footer" ng-hide="succeed || loading">
              <button
                type="button"
                className="btn btn-link product-quickview-modal-close"
                ng-disabled="progress"
                data-dismiss="modal"
              >
                انصراف
              </button>
              <button
                className="btn btn-success product-quickview-modal-submit"
                ng-disabled="progress"
              >
                افزودن به سبد خرید
              </button>
            </div>
          </div>
        </div>
      </form>
      {/*/quickview*/}
      {/*/quickview*/}
    </>
  );
};

export default Home;
